import React from 'react';
import { observer } from 'mobx-react-lite';
import TaskGroup from '../taskGroup';
import type { TaskGroupModalActions } from '../taskGroup';
import type { WorkspaceModel } from '../../../../../mobx/models/workspace';
import type { ProjectModel } from '../../../../../mobx/models/project';
import type { ProjectTemplateModel } from '../../../../../mobx/models/projectTemplate';
import type { MobxFilteredTasksListInterface, NewTaskFilterInterface } from '../../../../../interfaces/TaskInterface';
import type { TaskModel } from '../../../../../mobx/models/task';
import type { StatusListInterface } from '../../../../../interfaces/ProjectInterface';

export interface FilteredTaskListProps {
  filteredTasksList?: MobxFilteredTasksListInterface[];
  collapseIds: string[];
  handleCollapseClick: (id: string) => void;
  loadData: () => void;
  currentWorkspace: WorkspaceModel | null;
  taskFilter: NewTaskFilterInterface | undefined;
  isTemplateProject: boolean | undefined;
  currentProject: ProjectModel | ProjectTemplateModel | null;
  isView: boolean | undefined;
  showProjectName: boolean | undefined;
  selectedId: string;
  showCompletedTask: boolean;
  openSubTask: { id: string; showCompleted: boolean };
  isSelected: (groupId: string, taskId: string) => boolean;
  handleHoverTask: (groupId: string, taskId: string, isCompleted?: boolean) => void;
  onClickTaskCheckBox: (task: TaskModel) => void;
  onChangeStatus: (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => void;
  handleSubtaskOpen: (id: string) => void;
  handleShowCompletedSubTask: (id: string, isShow: boolean) => void;
  toggleCompletedTask: (show: boolean, comparedValue: string) => void;
  getSubtaskData: (task: TaskModel) => {
    visibleSubtasks: TaskModel[];
    completedSubtasks: TaskModel[];
    hasCompleted: boolean;
  };
  modalActions: TaskGroupModalActions;
  maxVisibleLabels: number;
}

const FilteredTaskList = observer(function FilteredTaskList({
  filteredTasksList,
  collapseIds,
  handleCollapseClick,
  loadData,
  currentWorkspace,
  taskFilter,
  isTemplateProject,
  currentProject,
  isView,
  showProjectName,
  selectedId,
  showCompletedTask,
  openSubTask,
  isSelected,
  handleHoverTask,
  onClickTaskCheckBox,
  onChangeStatus,
  handleSubtaskOpen,
  handleShowCompletedSubTask,
  toggleCompletedTask,
  getSubtaskData,
  modalActions,
  maxVisibleLabels
}: FilteredTaskListProps) {
  return (
    <>
      {filteredTasksList?.map((item) => (
        <TaskGroup
          key={item?.id}
          item={item}
          collapseIds={collapseIds}
          handleCollapseClick={handleCollapseClick}
          loadData={loadData}
          currentWorkspace={currentWorkspace}
          taskFilter={taskFilter}
          isTemplateProject={isTemplateProject}
          currentProject={currentProject}
          isView={isView}
          showProjectName={showProjectName}
          selectedId={selectedId}
          showCompletedTask={showCompletedTask}
          openSubTask={openSubTask}
          isSelected={isSelected}
          handleHoverTask={handleHoverTask}
          onClickTaskCheckBox={onClickTaskCheckBox}
          onChangeStatus={onChangeStatus}
          handleSubtaskOpen={handleSubtaskOpen}
          handleShowCompletedSubTask={handleShowCompletedSubTask}
          toggleCompletedTask={toggleCompletedTask}
          getSubtaskData={getSubtaskData}
          modalActions={modalActions}
          maxVisibleLabels={maxVisibleLabels}
        />
      ))}
    </>
  );
});

FilteredTaskList.displayName = 'FilteredTaskList';

export default FilteredTaskList;
